import { render } from "./TabTeacherComment.vue?vue&type=template&id=9d3c3fc8"
import script from "./TabTeacherComment.vue?vue&type=script&lang=js"
export * from "./TabTeacherComment.vue?vue&type=script&lang=js"

import "./TabTeacherComment.vue?vue&type=style&index=0&id=9d3c3fc8&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__